export {
  OnboardingCompletedDialogTutor,
  OnboardingCompletedDialogTutorProps,
  OnboardingCompletedDialogTutorFormValues,
} from './OnboardingCompletedDialogTutor';
